import React,{useState, useEffect} from 'react';
import LoadScreen from '../../components/loadScreen/loadScreen';
import EditorImage from '../../components/editorImage/editorImage';
import {Post,
    Button,
    SpanButton,
    DivPaiImage,
    DivImg,
    DivImgLiberado,
    ImgLiberado,
    LabelImageEditPost,
    InputTituloPost,
    DivTextPost,
    TextAreaTextPost,
    DivPaiImagePostLiberado,
    DivButtonSave,
    DivTextTitleText,
    DivButtonOption,
    DivPopupBannedList,
    DivCorfirm} from './newPostStyle';
import {InsertMyPost} from '../../services/servicesInsertMyPost';
import {getCheckPost} from '../../services/servicesCheckPost';
import Popup from "reactjs-popup";
import Toastify from '../../components/Toastify';
import InputFile from '../../components/inputs/inputFile/InputFile';
import {IconMdBorderColor} from '../../components/menu/styles';
import SmallScreen from '../../components/loadScreenSmall/loadScreenSmall';

export default function NovoTemplate(props){
    const img404 = require('../../assets/images/noData.png').default;
    const [fotoCarregada, setFotoCarregada] = useState(true);
    const [smallScreen, setSmallScreen] = useState(false)
    const [bannedWordList, setBannedWordList] = useState({});
    const [popupVerifyText, setPopupVerifyText] = useState(false);
    const [conteudoPost, setConteudoPost] = useState({Id:'',
    Image1:img404,
    PostText:'',
    PostTitle:'',
    Category:'',
    Date:'',
    PopularCount:'',
    KeyWords:''});
    const [editorImage, setEditorImage] = useState(false);
//configuração do toastify
    const [statusToastify, setStatusToastify]=useState('');
    const customId  = 'custom-id-yes';
    const Sucess = (mensagem) => Toastify.success(mensagem,{toastId:customId} );
    const Error = (mensagem) => Toastify.error(mensagem,{toastId:customId});

//fim configuração do toastify

    useEffect(()=>{
        Sucess('Preencha os campos');
    },[]);

    function editaTexto(event){
        event.preventDefault();
        setConteudoPost({...conteudoPost,PostText:event.target.value});
    };

    function editaTitulo(event){
        event.preventDefault();
        setConteudoPost({...conteudoPost,PostTitle:event.target.value});
    };

    async function verifyText(text){
        try{
            setSmallScreen(true);
            const data = await getCheckPost(text.toString());
            if(data.data.length > 0){
                setBannedWordList(data.data);
                setPopupVerifyText(true);
                setSmallScreen(false);
            }else{
                if(conteudoPost.Image1 !== img404 && conteudoPost.PostText !== '' && conteudoPost.PostTitle !== ''){
                    Toastify.success('Salvando.')
                    setSmallScreen(false);

                }else{
                    if(conteudoPost.Image1 === img404){
                        Toastify.error('Por favor insira uma imagem.')
                        setSmallScreen(false)
                        return;
                    }
                    if(conteudoPost.PostText === '' || conteudoPost.PostTitle === ''){
                        Toastify.error('Por preencha todos os campos.')
                        setSmallScreen(false)
                        return;
                    }
                }
                salvarPost()
            }
        }catch(erro){
            setSmallScreen(false);
            Toastify.error('Erro ao salvar.')
        }
    }

   async function salvarPost(){
        try {
            setSmallScreen(true);
            const salvandoPost = await InsertMyPost(conteudoPost);
            if (salvandoPost.status !== 400){
                setSmallScreen(false)
                Sucess('Post Salvo com sucesso');
            }else{
            Error('Não foi possível salvar o post');
            }
        }catch (error) {
        setSmallScreen(false)
            Error('Erro ao tentar realizar o cadastro do post');
        }

    }

    function erroPost(){
        Error();
    }
    function publishNewPost() {
        setPopupVerifyText(false);
        salvarPost();
    }
    function mountBannedList(array_word_list){
        if(array_word_list.length > 0)
        return array_word_list.map((item,index) =><div key={index} style={{margin:'10px 0 20px 0', borderBottom:'1px solid lightgrey',padding:'0 0 10px 0'}}><span style={{fontSize:'26px'}}><b>{item.Phrase}</b></span><br /><span style={{fontSize:'18px'}} >{item.Explanation}</span></div>)
    }

    return(<Post>
        <DivPaiImage>
                <DivPaiImagePostLiberado>
                    <div style={{height:'40px',marginBottom:'20px',display:'flex', justifyContent:'space-evenly'}}>
                        <InputFile mudaImg = {setConteudoPost}
                            imagem={conteudoPost}
                            load={fotoCarregada}
                            campo='Image1'
                            concluido={setFotoCarregada}/>
                        <Button onClick={()=>setEditorImage(true)}>
                            <SpanButton>Utilizar Editor</SpanButton>
                        </Button>
                    </div>
                    <DivImg>
                        <DivImgLiberado>
                            {
                                fotoCarregada ?
                                    <ImgLiberado id='canvas' src={conteudoPost.Image1} />
                                :
                                    <LoadScreen position='unset' />
                            }
                            <LabelImageEditPost htmlFor='FotoEditaPost'style={{position:'relative',bottom:'calc(100vh * 0.35)',height:'0'}}>
                                <IconMdBorderColor style={{fontSize:'40pt'}}/>
                            </LabelImageEditPost>
                        </DivImgLiberado>
                    </DivImg>
                </DivPaiImagePostLiberado>
        </DivPaiImage>
        <DivTextTitleText>
            <DivButtonSave>
                <Button onClick={()=>verifyText(conteudoPost.PostText)}>
                    <SpanButton>Salvar</SpanButton>
                </Button>
            </DivButtonSave>
                <InputTituloPost
                    placeholder='Insira o título do texto'
                    value={conteudoPost.PostTitle}
                    onChange={(event)=>{editaTitulo(event)}}
                />
            <DivTextPost id='divtextpost' >
                    <TextAreaTextPost
                        placeholder='Insira o conteúdo do post'
                        value={conteudoPost.PostText}
                        onChange={(event)=>{editaTexto(event)}}
                    />
            </DivTextPost>

        </DivTextTitleText>
        <Popup open={popupVerifyText} onClose={()=> setPopupVerifyText(false)} >
            <DivPopupBannedList>
                <div style={{margin:'10px 0'}}>
                    Encontramos os seguintes termo(s) abaixo que devem ser evitado(s):
                </div>
                <div style={{ maxHeight:'70vh',overflow:'auto'}}>
                    {mountBannedList(bannedWordList)}
                </div>
                <DivCorfirm>
                    <span>Deseja criar o post mesmo assim ?</span>
                    <DivButtonOption>
                        <Button onClick={publishNewPost}><SpanButton>Sim</SpanButton></Button>
                        <Button onClick={()=>setPopupVerifyText(false)} ><SpanButton>Não</SpanButton></Button>
                    </DivButtonOption>
                </DivCorfirm>
            </DivPopupBannedList>
        </Popup>
        <Popup open={ editorImage } onClose={()=>setEditorImage(false)} closeOnDocumentClick={false} closeOnEscape={false} contentStyle={{backgroundColor:'#1E1E1E',borderColor:'#1E1E1E',borderRadius:'4px',width:'fit-content',height:'fit-content'}}>
                <EditorImage text={conteudoPost.PostTitle} image={conteudoPost.Image1} exibe={setConteudoPost} close={setEditorImage} save={salvarPost} loadScreen={setSmallScreen}/>
        </Popup>
        {
            smallScreen ? <SmallScreen open={smallScreen} close={setSmallScreen} /> : ''
        }
    </Post>)
}
